import { _o as K, xn as Q, yn as D } from "./icon-CJVFAm1E.js";
import { t as x } from "./isDefined-fMi6eQ4r.js";
import { t as U } from "./theme-B90C-74v.js";
import { n as E, r as W, s as Y } from "./Input-DOoSscrP.js";
import { t as i } from "./mergeClassNames-BHKm1BNi.js";
import { n as _, r as f, t as u } from "./ListItem.module-2-JdpOva.js";
import { clsx as v } from "clsx";
import { Fragment as Z, jsx as a, jsxs as N } from "react/jsx-runtime";
import { isBoolean as ee, isFunction as V, isNumber as re } from "@sniptt/guards";
import { forwardRef as T, useLayoutEffect as ae, useMemo as oe, useRef as te } from "react";
import { useRender as q } from "@base-ui/react/use-render";
import { useDirection as le } from "@base-ui/react/direction-provider";
import { Radio as ie } from "@base-ui/react/radio";
import { Input as ne } from "@base-ui/react/input";
import { Checkbox as L } from "@base-ui/react/checkbox";
import { Field as C } from "@base-ui/react/field";
import { RadioGroup as B } from "@base-ui/react/radio-group";
import { Select as c } from "@base-ui/react/select";
import { Slider as b } from "@base-ui/react/slider";
var se = "_container_1nftd_1", ce = { container: se }, Lr = ({ attached: e = !0, framed: r = !1, className: o, children: t, variant: l, size: s, color: n, render: d, ref: m, ...g }) => {
  const I = q({
    render: d,
    ref: m,
    props: {
      role: "group",
      "data-attached": e || void 0,
      "data-framed": r || void 0,
      ...g,
      className: v(ce.container, o),
      children: t
    }
  });
  return /* @__PURE__ */ a(Y.Provider, {
    value: {
      variant: l,
      color: n,
      size: s
    },
    children: I
  });
}, yr = ({ size: e = "sm", variant: r = "solid", shape: o = "square", color: t = "accent", hoverable: l = !0, className: s, children: n, ...d }) => /* @__PURE__ */ N(L.Root, {
  ...d,
  className: i(v(_.root, _[e], _[r], _[o], _[t], l && _.hoverable), s),
  children: [/* @__PURE__ */ a("span", {
    className: _.box,
    children: /* @__PURE__ */ N(L.Indicator, {
      className: _.indicator,
      children: [/* @__PURE__ */ a(D, {
        className: _.check,
        "aria-hidden": !0
      }), /* @__PURE__ */ a(K, {
        className: _.minus,
        "aria-hidden": !0
      })]
    })
  }), n]
}), de = "_description_yrj5x_1", me = { description: de }, P = T(({ className: e, ...r }, o) => /* @__PURE__ */ a(C.Description, {
  ref: o,
  className: i(me.description, e),
  ...r
}));
P.displayName = "FieldDescription";
var _e = "_error_179et_1", ue = { error: _e }, A = T(({ className: e, ...r }, o) => /* @__PURE__ */ a(C.Error, {
  ref: o,
  className: i(ue.error, e),
  ...r
}));
A.displayName = "FieldError";
var ve = "_label_1yxve_1", pe = { label: ve }, H = T(({ className: e, ...r }, o) => /* @__PURE__ */ a(C.Label, {
  ref: o,
  className: i(pe.label, e),
  ...r
}));
H.displayName = "FieldLabel";
var Gr = {
  Root: C.Root,
  Label: H,
  Control: C.Control,
  Description: P,
  Error: A,
  Validity: C.Validity
}, he = "_root_q5j74_1", fe = "_sm_q5j74_27", Ne = "_md_q5j74_31", be = "_startElement_q5j74_35", ge = "_endElement_q5j74_36", w = {
  root: he,
  sm: fe,
  md: Ne,
  startElement: be,
  endElement: ge
}, y = (e) => x(e) && !ee(e) && e !== "", Fr = ({ size: e = "md", startElement: r, endElement: o, className: t, children: l, render: s, ref: n, ...d }) => {
  const m = q({
    render: s,
    ref: n,
    props: {
      ...d,
      className: v(w.root, w[e], t),
      children: /* @__PURE__ */ N(Z, { children: [
        y(r) && /* @__PURE__ */ a("span", {
          className: w.startElement,
          children: r
        }),
        l,
        y(o) && /* @__PURE__ */ a("span", {
          className: w.endElement,
          children: o
        })
      ] })
    }
  });
  return /* @__PURE__ */ a(W.Provider, {
    value: { size: e },
    children: m
  });
}, Se = "_root_1h79s_1", xe = { root: Se }, jr = ({ className: e, ...r }) => /* @__PURE__ */ a(B, {
  ...r,
  className: i(xe.root, e)
}), Ce = "_container_1uovu_1", Ie = "_item_1uovu_20", Re = "_iconOnly_1uovu_60", we = "_icon_1uovu_60", Te = "_label_1uovu_79", R = {
  container: Ce,
  item: Ie,
  iconOnly: Re,
  icon: we,
  label: Te
}, Dr = ({ className: e, itemWidth: r = "equal", options: o, ...t }) => /* @__PURE__ */ a(B, {
  ...t,
  className: i(R.container, e),
  "data-item-width": r,
  children: o.map(({ "aria-label": l, disabled: s, label: n, startIcon: d, value: m }) => /* @__PURE__ */ N(ie.Root, {
    value: m,
    disabled: s,
    "aria-label": l,
    className: v(R.item, !f(n) && R.iconOnly),
    children: [f(d) && /* @__PURE__ */ a("span", {
      className: R.icon,
      "aria-hidden": !0,
      children: d
    }), f(n) && /* @__PURE__ */ a("span", {
      className: R.label,
      children: n
    })]
  }, m))
}), $e = "_trigger_wig41_1", ke = "_value_wig41_12", Ee = "_icon_wig41_31", Le = "_positioner_wig41_42", ye = "_popup_wig41_46", Ge = "_item_wig41_71", Fe = "_indicator_wig41_75", je = "_groupLabel_wig41_81", De = "_separator_wig41_89", p = {
  trigger: $e,
  value: ke,
  icon: Ee,
  positioner: Le,
  popup: ye,
  item: Ge,
  indicator: Fe,
  groupLabel: je,
  separator: De
}, Ve = ({ className: e, ...r }) => /* @__PURE__ */ a(c.GroupLabel, {
  ...r,
  className: i(p.groupLabel, e)
}), qe = ({ className: e, children: r, startIcon: o, endIcon: t, description: l, descriptionPlacement: s = "inline", ...n }) => /* @__PURE__ */ N(c.Item, {
  ...n,
  className: i(v(u.root, p.item), e),
  "data-color": "neutral",
  "data-indicator": "check",
  children: [
    f(o) && /* @__PURE__ */ a("div", {
      className: u.startIcon,
      "aria-hidden": !0,
      children: o
    }),
    /* @__PURE__ */ N("div", {
      className: u.label,
      children: [/* @__PURE__ */ a(c.ItemText, {
        className: u.text,
        children: r
      }), f(l) && s === "inline" && /* @__PURE__ */ a("div", {
        className: v(u.description, u.inlineDescription),
        children: l
      })]
    }),
    f(l) && s === "end" && /* @__PURE__ */ a("div", {
      className: v(u.description, u.endDescription),
      children: l
    }),
    f(t) && /* @__PURE__ */ a("div", {
      className: u.endIcon,
      "aria-hidden": !0,
      children: t
    }),
    /* @__PURE__ */ a(c.ItemIndicator, {
      className: p.indicator,
      children: /* @__PURE__ */ a(D, { className: u.checkIndicator })
    })
  ]
}), Be = ({ side: e = "bottom", align: r = "start", sideOffset: o = 8, alignOffset: t, alignItemWithTrigger: l = !1, anchor: s, container: n, className: d, ...m }) => {
  const g = U(), I = le();
  return /* @__PURE__ */ a(c.Portal, {
    container: n === void 0 ? g ?? void 0 : n,
    children: /* @__PURE__ */ a(c.Positioner, {
      dir: I,
      side: e,
      align: r,
      sideOffset: o,
      alignOffset: t,
      alignItemWithTrigger: l,
      anchor: s,
      className: p.positioner,
      children: /* @__PURE__ */ a(c.Popup, {
        ...m,
        className: i(p.popup, d)
      })
    })
  });
}, Pe = ({ className: e, ...r }) => /* @__PURE__ */ a(c.Separator, {
  ...r,
  className: i(p.separator, e)
}), Ae = ({ size: e = "md", className: r, children: o, ...t }) => /* @__PURE__ */ N(c.Trigger, {
  ...t,
  className: i(v(E.input, E[e], p.trigger), r),
  children: [o, /* @__PURE__ */ a(c.Icon, {
    className: p.icon,
    children: /* @__PURE__ */ a(Q, {})
  })]
}), He = ({ className: e, ...r }) => /* @__PURE__ */ a(c.Value, {
  ...r,
  className: i(p.value, e)
}), Me = () => ({
  Root: c.Root,
  Trigger: Ae,
  Value: He,
  Popup: Be,
  Item: qe,
  Group: c.Group,
  GroupLabel: Ve,
  Separator: Pe
}), Vr = /* @__PURE__ */ Me(), Oe = "_root_4ltwd_1", ze = "_accent_4ltwd_16", Xe = "_success_4ltwd_20", Je = "_control_4ltwd_24", Ke = "_track_4ltwd_42", Qe = "_indicator_4ltwd_55", Ue = "_thumb_4ltwd_66", We = "_label_4ltwd_80", Ye = "_value_4ltwd_81", h = {
  root: Oe,
  accent: ze,
  success: Xe,
  control: Je,
  track: Ke,
  indicator: Qe,
  thumb: Ue,
  label: We,
  value: Ye
}, Ze = ({ className: e, color: r = "accent", thumbAlignment: o = "edge", ...t }) => /* @__PURE__ */ a(b.Root, {
  ...t,
  thumbAlignment: o,
  className: i(v(h.root, h[r]), e)
}), er = ({ className: e, ...r }) => /* @__PURE__ */ a(b.Control, {
  ...r,
  className: i(h.control, e)
}), rr = ({ className: e, ...r }) => /* @__PURE__ */ a(b.Track, {
  ...r,
  className: i(h.track, e)
}), ar = ({ className: e, ...r }) => /* @__PURE__ */ a(b.Indicator, {
  ...r,
  className: i(h.indicator, e)
}), or = ({ className: e, ...r }) => /* @__PURE__ */ a(b.Thumb, {
  ...r,
  className: i(h.thumb, e)
}), tr = ({ className: e, ...r }) => /* @__PURE__ */ a(b.Label, {
  ...r,
  className: i(h.label, e)
}), lr = ({ className: e, ...r }) => /* @__PURE__ */ a(b.Value, {
  ...r,
  className: i(h.value, e)
}), qr = {
  Root: Ze,
  Control: er,
  Track: rr,
  Indicator: ar,
  Thumb: or,
  Label: tr,
  Value: lr
}, ir = (e) => x(e) ? re(e) ? `${e}px` : String(e) : "", G = (e, r) => {
  if (x(e)) {
    if (V(e)) return e(r);
    e.current = r;
  }
}, nr = (...e) => (r) => {
  const o = e.map((t) => {
    const l = G(t, r);
    return V(l) ? l : () => G(t, null);
  });
  return () => {
    for (const t of o) t();
  };
}, F = (e) => {
  e.style.blockSize = "auto";
  const r = e.offsetHeight - e.clientHeight;
  e.style.blockSize = `${e.scrollHeight + r}px`;
}, sr = "_textarea_1ob5j_1", cr = "_sm_1ob5j_38", dr = "_md_1ob5j_42", j = {
  textarea: sr,
  sm: cr,
  md: dr
}, mr = /* @__PURE__ */ a("textarea", {}), Br = ({ size: e = "md", autoResize: r = !1, maxRows: o, className: t, style: l, ref: s, render: n = mr, onChange: d, value: m, rows: g, ...I }) => {
  const $ = te(null), M = oe(() => nr(s, $), [s]), O = x(m), k = l?.blockSize;
  ae(() => {
    const S = $.current;
    if (x(S)) {
      if (!r) {
        S.style.blockSize = ir(k);
        return;
      }
      F(S);
    }
  }, [
    r,
    m,
    o,
    g,
    k
  ]);
  const z = (S) => {
    r && !O && F(S.currentTarget), d?.(S);
  }, X = x(o) ? {
    ...l,
    "--ui-textarea-max-rows": o
  } : l, J = {
    ...I,
    rows: g,
    onChange: z
  };
  return /* @__PURE__ */ a(ne, {
    ...J,
    ref: M,
    render: n,
    value: m,
    className: i(v(j.textarea, j[e]), t),
    style: X,
    "data-auto-resize": r || void 0
  });
};
export {
  jr as a,
  yr as c,
  Dr as i,
  Lr as l,
  qr as n,
  Fr as o,
  Vr as r,
  Gr as s,
  Br as t
};
